import React, { useState } from 'react';
import { Typography, Button, Checkbox } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Steps } from '../PreJoinScreens';

const GutterBottomTypography = styled(Typography)({
  marginBottom: '1em',
  textAlign: 'center',
});

const ConfirmLabel = styled('div')({
  display: 'flex',
  '& .MuiCheckbox-root': {
    paddingLeft: '0px',
  },
  '& span': {
    fontSize: '0.842rem',
    display: 'flex',
    alignItems: 'center',
  },
});

const JoinButtons = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column-reverse',
    width: '100%',
    '& button': {
      margin: '0.5em 0',
    },
  },
}));

const BodyText = styled(Typography)({
  marginBottom: '1em',
  whiteSpace: 'pre-line',
  overflowY: 'auto',
  maxHeight: '150px',
});

interface DisclaimerScreenProps {
  disclaimer: string;
  setStep: (step: Steps) => void;
}

export default function DisclaimerScreen({ disclaimer, setStep }: DisclaimerScreenProps) {
  const [confirm, setConfirm] = useState(false);

  return (
    <>
      <GutterBottomTypography variant="h5">
        Disclaimer
      </GutterBottomTypography>
      <BodyText variant="body1">
        {disclaimer}
      </BodyText>
      <ConfirmLabel>
        <Checkbox checked={confirm} onChange={() => { setConfirm(!confirm) }} name="confirmDeclaration" color="primary" />
        <span>I hereby confirm that I have read and understood the above statement</span>
      </ConfirmLabel>
      <JoinButtons>
        <Button
          disabled={!confirm}
          variant="contained"
          color="primary"
          data-cy-join-now
          onClick={confirm ? () => setStep(Steps.deviceSelectionStep) : () => { }}
        >
          Continue To Meeting
        </Button>
      </JoinButtons>
    </>
  );
}
